import React from 'react';
import { Section } from './ui/Section';
export function PainMirror() {
  return <Section alternate className="relative overflow-hidden" data-id="element-180">
      {/* Decorative element */}
      <div className="absolute left-0 top-20 bottom-20 w-[1px] bg-gradient-to-b from-transparent via-[#c9a04e]/30 to-transparent hidden md:block" data-id="element-181"></div>

      <div className="space-y-8 pl-0 md:pl-8 border-l-0 md:border-l border-[#c9a04e]/20" data-id="element-182">
        <h2 className="text-3xl md:text-4xl text-[#f5f0e8] mb-8" data-id="element-183">
          Esto es lo que nadie te dice del "insomnio" de mente acelerada
        </h2>

        <div className="space-y-6 text-lg text-[#f5f0e8]/90 leading-relaxed" data-id="element-184">
          <p data-id="element-185">La mayoría de noches no estás "sin sueño".</p>
          <p className="text-xl text-[#c9a04e]" data-id="element-186">Estás sin cierre.</p>
          <p data-id="element-187">
            Tu cuerpo pide cama.
            <br data-id="element-188" />
            Tu cerebro pide control.
          </p>
          <p data-id="element-189">
            Y como durante el día fuiste capaz de tirar…
            <br data-id="element-190" />
            por la noche tu cerebro se cobra la factura.
          </p>
          <p data-id="element-191">No porque seas débil.</p>
          <p data-id="element-192">
            Porque es el primer momento del día donde ya no hay ruido para
            taparlo.
          </p>
        </div>
      </div>
    </Section>;
}